export default __webpack_public_path__ + "static/media/inside.3fc143ec.png";